import { render, staticRenderFns } from "./ShowofforumCreate.vue?vue&type=template&id=3fcca9a6&"
import script from "./ShowofforumCreate.vue?vue&type=script&lang=js&"
export * from "./ShowofforumCreate.vue?vue&type=script&lang=js&"
import style0 from "./ShowofforumCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports